<template>
  <div
    class="min-h-screen flex flex-col bg-white text-gray-900 dark:bg-gray-950 dark:text-gray-100 transition-colors duration-200"
  >
    <!-- Skip link for keyboard users -->
    <a href="#content" class="skip-link">Skip to content</a>

    <AppHeader />

    <main id="content" class="flex-1" tabindex="-1">
      <slot />
    </main>

    <AppFooter />
  </div>
</template>
